import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_12 = { class: "io-calculator__usage-field__popover__slider" }

import {
  computed,
  ref,
  onBeforeMount,
  watch,
  nextTick,
} from 'vue';

import InputField from '@/components/InputField.vue';
import IoSlider from '@/components/inputs/Slider.vue';
import ClickWrapper from '@/components/ClickWrapper.vue';
import IconPower1 from '@/components/icons/IconPower1.vue';
import IconPower2 from '@/components/icons/IconPower2.vue';
import IconPower3 from '@/components/icons/IconPower3.vue';
import IconPower4 from '@/components/icons/IconPower4.vue';
import IconPower5 from '@/components/icons/IconPower5.vue';
import IconGas1 from '@/components/icons/IconGas1.vue';
import IconGas2 from '@/components/icons/IconGas2.vue';
import IconGas3 from '@/components/icons/IconGas3.vue';
import IconGas4 from '@/components/icons/IconGas4.vue';
import IconGas5 from '@/components/icons/IconGas5.vue';
import { env, formatNumber } from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {},
  label: {
    type: String,
    required: true,
  },
  showValidCheck: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  branch: {
    type: String,
    required: true,
    default: 'power',
  },
},
  emits: [
  'update:modelValue',
  'changeIcon',
  'keyup',
  'input',
],
  setup(__props, { emit }) {

const props = __props





const root = ref<InstanceType<typeof ClickWrapper>>();
const popover = ref<InstanceType<typeof HTMLElement>>();
const iconRow = ref<InstanceType<typeof HTMLElement>>();
const iconRowWrapper = ref<InstanceType<typeof HTMLElement>>();

const percentage = ref(25);
const isOpen = ref(false);
const selectedIcon = ref(1);

const iconColor = computed(() => [
  selectedIcon.value === 0 ? 'var(--color-brand-primary)' : '#DBDBDB',
  selectedIcon.value === 1 ? 'var(--color-brand-primary)' : '#DBDBDB',
  selectedIcon.value === 2 ? 'var(--color-brand-primary)' : '#DBDBDB',
  selectedIcon.value === 3 ? 'var(--color-brand-primary)' : '#DBDBDB',
  selectedIcon.value === 4 ? 'var(--color-brand-primary)' : '#DBDBDB',
]);

const onKeyUp = (e: unknown) => {
  emit('keyup', e);
};

const preSelectValues = computed(() => {
  switch (props.branch) {
    case 'gas':
      return [
        3500,
        7500,
        15000,
        25000,
        40000,
      ];
    default:
      return [
        1500,
        2500,
        3500,
        4500,
        5000,
      ];
  }
});

const maxUsage = computed(() => {
  switch (props.branch) {
    case 'gas':
      return env('CALCULATOR_GAS_MAX', 100000);
    default:
      return env('CALCULATOR_POWER_MAX', 99999);
  }
});

const minUsage = computed(() => {
  switch (props.branch) {
    case 'gas':
      return 600;
    default:
      return 100;
  }
});

const sliderSteps = computed(() => {
  const steps = [];

  const pv = preSelectValues.value;
  const maxu = maxUsage.value;
  const minu = minUsage.value;

  const stepSize = maxu / (pv.length + 1);
  // eslint-disable-next-line no-bitwise
  for (let i = 0; i < (pv.length + 1); i += 1) {
    const stepMin = pv[i - 1] || minu;
    const stepMax = pv[i] ? (pv[i] - 1) : maxu;

    steps.push({
      size: stepSize,
      range: stepMax - stepMin,
      min: stepMin,
      max: stepMax,
      percentage: ((stepSize / maxu) * i * 100),
    });
  }

  return steps;
});

const getCurrentStepByPercentage = (pc: number) => {
  const pv = preSelectValues.value;
  const mu = maxUsage.value;

  const stepSize = mu / (pv.length + 1);
  // eslint-disable-next-line no-bitwise
  let currentStep = ~~(pc / stepSize);
  if (currentStep > (sliderSteps.value.length - 1)) {
    currentStep = sliderSteps.value.length - 1;
  }
  const step = sliderSteps.value[currentStep];
  const stepPercentage = (pc - (currentStep * step.size)) / step.size;

  return {
    num: currentStep,
    size: step.size,
    min: step.min,
    max: step.max,
    percentage: stepPercentage,
  };
};

const getPercentageByValue = (v: number) => {
  const cstep = sliderSteps.value.filter((s) => s.min <= v && s.max >= v)[0];

  if (cstep) {
    const cstepPercentage = (v - cstep.min) / cstep.range;
    const cp = (cstepPercentage * ((cstep.size / maxUsage.value) * 100)) + cstep.percentage;

    return (cp / 100) * maxUsage.value;
  }

  return 0;
};

const calculateValueByPercentage = (percent: number) => {
  const step = getCurrentStepByPercentage(percent);

  selectedIcon.value = step.num;

  return Math.ceil(step.min + ((step.max - step.min) * step.percentage));
};

const sliderDragValue = ref(preSelectValues.value[0]);

const value = computed({
  get(): unknown {
    return props.modelValue;
  },
  set(newValue: unknown): void {
    sliderDragValue.value = getPercentageByValue(newValue as number);
    emit('update:modelValue', newValue);
  },
});

const onClickIcon = (iconInx: number) => {
  value.value = preSelectValues.value[iconInx];

  if (/Android|Mobi|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isOpen.value = false;
  }
};

onBeforeMount(() => {
  if (value.value) {
    // eslint-disable-next-line prefer-destructuring
    const val = value.value as number;
    if (!value.value || val < minUsage.value || val > maxUsage.value) {
      // eslint-disable-next-line prefer-destructuring
      value.value = preSelectValues.value[0];
    } else {
      // eslint-disable-next-line prefer-destructuring
      value.value = preSelectValues.value[1];
    }
  } else {
    // eslint-disable-next-line prefer-destructuring
    value.value = preSelectValues.value[1];
  }

  percentage.value = getPercentageByValue(value.value as number);
  sliderDragValue.value = percentage.value;
  emit('changeIcon', selectedIcon.value);
});

const updateSliderValue = (val: number) => {
  value.value = calculateValueByPercentage(val);
};

const formatTooltip = (v: number) => `${formatNumber(calculateValueByPercentage(v), 0)} kWh`;

watch(() => isOpen.value, () => {
  if (isOpen.value) {
    nextTick(() => {
      if (root.value && popover.value) {
        popover.value.style.minWidth = '';
        popover.value.style.position = 'fixed';
        popover.value.style.position = 'absolute';
        popover.value.style.minWidth = 'calc(100% + 2em)';
      }
    });
  }
});

watch(() => selectedIcon.value, () => {
  emit('changeIcon', selectedIcon.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ClickWrapper, {
    class: _normalizeClass(["io-calculator__usage-field", { 'open': isOpen.value }]),
    onOutside: _cache[13] || (_cache[13] = ($event: any) => (isOpen.value = false)),
    ref: (_value, _refs) => {
      _refs['root'] = _value
      root.value = _value
    }
  }, {
    default: _withCtx(() => [
      _createVNode(InputField, {
        label: __props.label,
        type: "number",
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        min: _unref(minUsage),
        max: _unref(maxUsage),
        "only-numeric": true,
        showValidCheck: __props.showValidCheck,
        borderless: "",
        "icon-left": "fal fa-chart-pie-alt",
        onFocusin: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = true)),
        onKeyup: onKeyUp
      }, null, 8, ["label", "modelValue", "min", "max", "showValidCheck"]),
      _withDirectives(_createElementVNode("div", {
        class: "io-calculator__usage-field__popover",
        ref: (_value, _refs) => {
          _refs['popover'] = _value
          popover.value = _value
        }
      }, [
        _createElementVNode("div", {
          class: "io-calculator__usage-field__popover__icons",
          ref: (_value, _refs) => {
            _refs['iconRowWrapper'] = _value
            iconRowWrapper.value = _value
          }
        }, [
          _createElementVNode("div", {
            class: "row g-2",
            ref: (_value, _refs) => {
              _refs['iconRow'] = _value
              iconRow.value = _value
            }
          }, [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              (__props.branch === 'gas')
                ? (_openBlock(), _createBlock(IconGas1, {
                    key: 0,
                    color: _unref(iconColor)[0],
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (onClickIcon(0)))
                  }, null, 8, ["color"]))
                : (_openBlock(), _createBlock(IconPower1, {
                    key: 1,
                    color: _unref(iconColor)[0],
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickIcon(0)))
                  }, null, 8, ["color"]))
            ]),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              (__props.branch === 'gas')
                ? (_openBlock(), _createBlock(IconGas2, {
                    key: 0,
                    color: _unref(iconColor)[1],
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (onClickIcon(1)))
                  }, null, 8, ["color"]))
                : (_openBlock(), _createBlock(IconPower2, {
                    key: 1,
                    color: _unref(iconColor)[1],
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (onClickIcon(1)))
                  }, null, 8, ["color"]))
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (__props.branch === 'gas')
                ? (_openBlock(), _createBlock(IconGas3, {
                    key: 0,
                    color: _unref(iconColor)[2],
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (onClickIcon(2)))
                  }, null, 8, ["color"]))
                : (_openBlock(), _createBlock(IconPower3, {
                    key: 1,
                    color: _unref(iconColor)[2],
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (onClickIcon(2)))
                  }, null, 8, ["color"]))
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (__props.branch === 'gas')
                ? (_openBlock(), _createBlock(IconGas4, {
                    key: 0,
                    color: _unref(iconColor)[3],
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (onClickIcon(3)))
                  }, null, 8, ["color"]))
                : (_openBlock(), _createBlock(IconPower4, {
                    key: 1,
                    color: _unref(iconColor)[3],
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (onClickIcon(3)))
                  }, null, 8, ["color"]))
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (__props.branch === 'gas')
                ? (_openBlock(), _createBlock(IconGas5, {
                    key: 0,
                    color: _unref(iconColor)[4],
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (onClickIcon(4)))
                  }, null, 8, ["color"]))
                : (_openBlock(), _createBlock(IconPower5, {
                    key: 1,
                    color: _unref(iconColor)[4],
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (onClickIcon(4)))
                  }, null, 8, ["color"]))
            ]),
            _hoisted_11
          ], 512)
        ], 512),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(IoSlider, {
            onChange: updateSliderValue,
            modelValue: sliderDragValue.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((sliderDragValue).value = $event)),
            max: _unref(maxUsage),
            step: 1,
            tooltip: true,
            "tooltip-show": "drag",
            "tooltip-format": formatTooltip
          }, null, 8, ["modelValue", "max"])
        ])
      ], 512), [
        [_vShow, isOpen.value]
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})